import { Box, Stack, Typography } from "@mui/material"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import Iconify from "minimals-template/components/Iconify"

export function PdfTaskChangeSummaryItem({ item }) {
    return (
        <Box
            sx={{
                flex: 1,
                px: "12px",
                py: "10px",
                borderRight: item?.isLast ? "none" : "1px solid #d7dce2",
                minHeight: "54px",
            }}
        >
            <Typography sx={{ fontSize: "9px", color: "#7b8794", mb: "6px" }}>{item.label}</Typography>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                {renderTaskChangeValue(item.from, item.valueType, true)}
                <Typography sx={{ fontSize: "14px", lineHeight: 1, color: "#1f2937" }}>&rarr;</Typography>
                {renderTaskChangeValue(item.to, item.valueType, false)}
            </Stack>
        </Box>
    )
}

function renderTaskChangeValue(value, valueType, emphasize) {
    if (valueType === "classification") {
        const icon = ICON_FROM_CLASSIFICATION[value]
        const color = COLOR_FROM_CLASSIFICATION[value] ?? "#7b8794"
        if (icon) {
            return (
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <Iconify icon={icon} width={14} height={14} style={{ color, flex: "0 0 auto" }} />
                    <Typography
                        sx={{
                            fontWeight: emphasize ? 700 : 400,
                            fontSize: "10px",
                            color: emphasize ? "#1f2937" : "#7b8794",
                        }}
                    >
                        ({value})
                    </Typography>
                </Stack>
            )
        }
    }

    return (
        <Typography
            sx={{
                fontWeight: emphasize ? 700 : 400,
                fontSize: "10px",
                color: emphasize ? "#1f2937" : "#7b8794",
            }}
        >
            {value}
        </Typography>
    )
}
